import BodyWrapper from 'app/partials/entity/BodyWrapper';
import React from 'react';
import { Ride } from 'app/modules/tp/rides/_models';
import RideAPI from 'app/modules/tp/rides/_requests';
import Table, { Column, defaultMetaPagination } from "app/partials/entity/Table";
import { Filters, IPaginationMeta, } from "app/modules/tp/_apiResponse";
import Pagination from '../../components/Pagination';
import moment from 'moment';
import { dateFormat } from "../_constants";
import { timeFormat } from "../../../../partials/form/DatetimeRangeInput";

type RideTableProps = {
    filters: Filters
    entities?: Array<Ride>
}

const columns: Array<Column<Ride>> = [
    //{
    //    key: "service",
    //    label: "Titolo Servizio",
    //    render: (ride: Ride) => (<>{ride.service?.title}</>),
    //},
    //{
    //    key: "client",
    //    label: "Cliente",
    //    render: (ride: Ride) => (<>{ride.service?.client?.displayed_name}</>),
    //},
    {
        key: "itinerary",
        label: "Itinerario",
        render: (ride: Ride) => (<>{ride?.itinerary ?? ""}</>),
    },
    {
        key: "start_departure_date",
        label: "Data inizio",
        render: (ride: Ride) => (<>{ride.start_departure_date ? moment(ride.start_departure_date, "DD/MM/YYYY HH:mm").format(`${dateFormat} ${timeFormat}`) : ''}</>),
    },
    {
        key: "end_departure_date",
        label: "Data fine",
        render: (ride: Ride) => (<>{ride.end_departure_date ? moment(ride.end_departure_date, "DD/MM/YYYY HH:mm").format(`${dateFormat} ${timeFormat}`) : ''}</>),
    },
    {
        key: "mean",
        label: "Mezzo",
        render: (ride: Ride) => (<>{`${ride.mean?.license_plate?.trim?.length > 0 ? (ride.mean?.license_plate + "/") : ""} ${ride.mean?.seats || 0} pt`}</>),
    },
    {
        key: "effort_hours",
        label: "Ore di impegno",
    },
    {
        key: "driving_hours",
        label: "Ore di guida",
    }
];

export const RideTable = ({ filters, entities: staticEntities }: RideTableProps): JSX.Element => {

    const [entities, setEntities] = React.useState<Array<Ride>>([]);

    const [pagination, setPagination] = React.useState<IPaginationMeta>({
        ...defaultMetaPagination,
        last_page: Math.ceil((staticEntities?.length ?? 0) / defaultMetaPagination.per_page),

    });

    const [sorters, setSorters] = React.useState<any>({
        sort_by: "start_departure_date",
    });

    const [AlertMessage, setAlertMessage] = React.useState<JSX.Element>(<></>);

    const loadEntities = async () => {
        if (staticEntities) {
            staticEntities?.sort((a, b) => {
                const a_start_departure_date = moment(a.start_departure_date, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD HH:mm");
                const b_start_departure_date = moment(b.start_departure_date, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD HH:mm");
                if(a_start_departure_date > b_start_departure_date) {
                    return 1;
                }
                if(a_start_departure_date < b_start_departure_date) {
                    return -1;
                }
                return 0;
            });
            setEntities(staticEntities?.slice((pagination?.current_page - 1) * pagination?.per_page, pagination?.current_page * pagination?.per_page));
            return;
        }
        const response = await RideAPI.getAll({ page: pagination?.current_page, filters, sorters }); if (response?.success) {
            setEntities(response.data as Array<Ride>);
        }
    }

    React.useEffect(() => {
        loadEntities();
    }, [pagination]);

    React.useEffect(() => {
        loadEntities();
    }, []);

    const onPageChange = (page: number) => {
        setPagination({
            ...pagination,
            current_page: page,
        });
    }
    return <div className='tp-modal-tablerel'>
        <BodyWrapper
            title={{
                label: "",
            }}
            footer={
                // @TODO: move Pagination in Table component
                <Pagination data={pagination} changePage={onPageChange} />
            }
        >
            {AlertMessage}
            <Table
                entities={entities}
                columns={columns}
                filters={filters}
                sorters={sorters}
                onChange={loadEntities}
                pagination={{
                    current_page: pagination?.current_page,
                    last_page: pagination?.last_page,
                    per_page: pagination?.per_page,
                    total: pagination?.total,
                }}
                onRowClick={() => { }}
            />
        </BodyWrapper>
    </div >
}
